import {Route} from '@angular/router';
import {initialDataResolver} from 'app/app.resolvers';
import {AccessGuard} from 'app/core/auth/guards/access.guard';
import {AuthGuard} from 'app/core/auth/guards/auth.guard';
import {UserManagementGuard} from './core/auth/guards/user-management.guard';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    {path: '', pathMatch: 'full', redirectTo: 'dashboard'},
    // Rota pública (sem autenticação): a segurança é o token do link enviado por email
    {
        path: 'aprovacao/:token',
        loadComponent: () => import('app/modules/approvals/approval-decision/approval-decision.component').then(m => m.ApprovalDecisionComponent),
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard, AccessGuard],
        loadComponent: () => import('app/layout/layout.component').then(m => m.LayoutComponent),
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
        ]
    },
    {
        path: '',
        loadComponent: () => import('app/layout/layout.component').then(m => m.LayoutComponent),
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'inicio', loadChildren: () => import('app/modules/landing/inicio/inicio.routes')},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')}
        ]
    },
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard, AccessGuard],
        loadComponent: () => import('app/layout/layout.component').then(m => m.LayoutComponent),
        resolve: {
            initialData: initialDataResolver
        },
        children: [
            {path: 'dashboard', loadChildren: () => import('app/modules/admin/home/home.routes')},
            {path: 'home', pathMatch: 'full', redirectTo: 'dashboard'},
            {path: 'instancias-glpi', loadComponent: () => import('./modules/admin/glpi/glpi').then(m => m.Glpi), data: {roles: 'instancias-glpi'}},
            {path: 'chamados', loadComponent: () => import('./modules/admin/chamados/chamados').then(m => m.Chamados), data: {roles: 'chamados-glpi'}},
            {
                path: 'chamados/novo',
                loadComponent: () => import('./modules/admin/chamados-novo/chamados-novo').then(m => m.ChamadosNovo),
                data: {
                    roles: 'chamados-glpi',
                    breadcrumbTrail: ['Atendimento', 'Chamados', 'Novo chamado']
                }
            },
            {
                path: 'chamados/:id',
                loadComponent: () => import('./modules/admin/chamado-detalhes/chamado-detalhes').then(m => m.ChamadoDetalhes),
                data: {
                    roles: 'chamados-glpi',
                    breadcrumbTrail: ['Atendimento', 'Chamados', 'Chamado #:id']
                }
            },
            {path: 'mudancas', loadComponent: () => import('./modules/admin/mudancas/listar-mudancas/listar-mudancas').then(m => m.Mudancas), data: {roles: 'mudancas-glpi'}},
            {
                path: 'mudancas/novo',
                loadComponent: () => import('./modules/admin/mudancas/criar-mudanca/criar-mudanca').then(m => m.MudancasNovo),
                data: {
                    roles: 'mudancas-glpi',
                    breadcrumbTrail: ['Atendimento', 'Mudanças', 'Nova mudança']
                }
            },
            {
                path: 'mudancas/:id',
                loadComponent: () => import('./modules/admin/mudancas/detalhar-mudanca/detalhar-mudanca').then(m => m.MudancaDetalhes),
                data: {
                    roles: 'mudancas-glpi',
                    breadcrumbTrail: ['Atendimento', 'Mudanças', 'mudança #:id']
                }
            },
            {path: 'problemas', loadComponent: () => import('./modules/admin/problemas/problemas').then(m => m.Problemas), data: {roles: 'problemas-glpi'}},
            {path: 'grupos', loadComponent: () => import('./modules/admin/grupos/grupos').then(m => m.Grupos), data: {roles: 'grupos-glpi'}},
            {
                path: 'problemas/:id',
                loadComponent: () => import('./modules/admin/problema-detalhes/problema-detalhes').then(m => m.ProblemaDetalhes),
                data: {
                    roles: 'problemas-glpi',
                    breadcrumbTrail: ['Atendimento', 'Problemas', 'Problema #:id']
                }
            },
            {
                path: 'recursos',
                loadComponent: () => import('./modules/admin/recursos/recursos').then(m => m.Recursos),
                data: {roles: 'recursos'}
            },
            {path: 'relatorios-metricas', loadComponent: () => import('./modules/admin/relatorios-metricas/relatorios-metricas').then(m => m.RelatoriosMetricas), data: {roles: 'relatorios-metricas'}},
            {path: 'parametros', loadComponent: () => import('./modules/admin/parametros/parametros').then(m => m.Parametros), data: {roles: 'parametros'}},
            {path: 'controle-funcional', loadComponent: () => import('./modules/admin/controle-funcional/controle-funcional').then(m => m.ControleFuncionalComponent), data: {roles: 'controle-funcional'}},
            {path: 'faq', loadComponent: () => import('./modules/admin/faq/faq').then(m => m.FaqComponent), data: {roles: 'faq-list'}},
            {path: 'faq-categorias', loadComponent: () => import('./modules/admin/faq/categorias/faq-categorias').then(m => m.FaqCategoriasComponent), data: {roles: 'faq-categories'}},
            {path: 'logs-requisicoes', loadComponent: () => import('./modules/admin/request-logs/request-logs.component').then(m => m.RequestLogsComponent), data: {roles: 'logs-requisicoes'}},
            {path: 'usuarios', loadComponent: () => import('./modules/admin/usuarios/usuarios').then(m => m.Usuarios), canActivate: [UserManagementGuard], data: {roles: 'usuarios-sso'}},
            {
                path: 'usuarios/cadastrar',
                loadComponent: () => import('./modules/admin/usuarios/formulario/usuarios-formulario').then(m => m.UsuariosMockComponent),
                canActivate: [UserManagementGuard],
                data: {
                    roles: 'usuarios-sso',
                    mode: 'cadastrar',
                    breadcrumbTrail: ['Gestão de Usuários', 'Usuários SSO', 'Cadastrar']
                }
            },
            {
                path: 'usuarios/:id/editar',
                loadComponent: () => import('./modules/admin/usuarios/formulario/usuarios-formulario').then(m => m.UsuariosMockComponent),
                canActivate: [UserManagementGuard],
                data: {
                    roles: 'usuarios-sso',
                    mode: 'editar',
                    breadcrumbTrail: ['Gestão de Usuários', 'Usuários SSO', 'Editar usuário']
                }
            },
            {
                path: 'usuarios/:id/detalhar',
                loadComponent: () => import('./modules/admin/usuarios/formulario/usuarios-formulario').then(m => m.UsuariosMockComponent),
                canActivate: [UserManagementGuard],
                data: {
                    roles: 'usuarios-sso',
                    mode: 'detalhar',
                    breadcrumbTrail: ['Gestão de Usuários', 'Usuários SSO', 'Detalhar usuário']
                }
            },
        ]
    }
];
